import React, {FC} from 'react';
import {useSelector} from 'react-redux';
import cn from 'classnames';
import {ClockType} from '@/common/constants/units';
import {useLocalizer} from '@/common/services/localizer';
import {WeatherAlert} from '@/app/interfaces/weather';
import {selectClockType} from '@/app/store/config/selectors';
import {InfoIcon} from '@/common/components/InfoIcon';
import styles from './WeatherAlertItem.css';

const getFormattedTime = (language: string, clockType: ClockType, hour: number, dateString?: string) => {
	const date = dateString ? new Date(dateString) : new Date();
	date.setHours(hour, 0, 0, 0);
	return date
		.toLocaleTimeString(language, {
			day: '2-digit',
			hour12: clockType === ClockType['12h'],
			month: '2-digit',
			year: 'numeric',
			hour: clockType === ClockType['12h'] ? 'numeric' : '2-digit',
			minute: '2-digit',
		})
		.toLowerCase();
};

interface WeatherAlertItemProps {
	className?: string;
	alert: WeatherAlert;
	date?: string;
	fromHour: number;
	toHour: number;
}

export const WeatherAlertItem: FC<WeatherAlertItemProps> = props => {
	const {className, alert, date, fromHour, toHour} = props;
	const {type, severity} = alert;

	const t = useLocalizer();
	const clockType = useSelector(selectClockType);

	const fromTime = getFormattedTime(t.language, clockType, fromHour, date);
	const toTime = getFormattedTime(t.language, clockType, toHour, date);

	return (
		<li className={cn(styles.root, styles[`type${type}`], styles[`severity${severity}`], className)}>
			<p className={styles.text}>{t(`weatherAlerts.${type}.${severity}`)}</p>
			<InfoIcon className={styles.iconIcon} title={t('weatherAlertInfo', {fromTime, toTime})} positionX='left' />
		</li>
	);
};

WeatherAlertItem.displayName = 'WeatherAlertItem';
